import { render, staticRenderFns } from "./docViewer_component.vue?vue&type=template&id=5a7c190c&scoped=true&"
import script from "./docViewer_component.vue?vue&type=script&lang=js&"
export * from "./docViewer_component.vue?vue&type=script&lang=js&"
import style0 from "./docViewer_component.vue?vue&type=style&index=0&id=5a7c190c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c190c",
  null
  
)

export default component.exports